import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

const Wrapper = styled.div`
  width: ${props => props.width || '100%'};
  padding: 30px;
  background: var(--glass-1);
  border: 1px solid var(--glass-border);
  border-radius: var(--radius, 16px);
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 20px;

  @media(max-width: 600px) {
    flex-direction: column;
    text-align: center;
  }
`;

const AvatarWrapper = styled.div`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  border: 3px solid var(--accent);
  padding: 3px;
  flex-shrink: 0;
`;

const Avatar = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  background: var(--glass-2);
`;

const Content = styled.div`
  flex: 1;
`;

const Name = styled.h3`
  margin: 0 0 5px 0;
  color: var(--text-primary);
  font-size: 20px;
`;

const Bio = styled.p`
  margin: 0;
  color: var(--text-secondary);
  font-size: 14px;
  line-height: 1.5;
`;

const AuthorBoxWidget = ({ node }) => {
  return (
    <Wrapper width={node.style?.desktop?.width}>
      <AvatarWrapper>
        <Avatar src={node.content?.avatarUrl || 'https://via.placeholder.com/150/1e293b/00A9E0?text=Author'} alt="Autor" />
      </AvatarWrapper>
      <Content>
        <Name>{node.content?.name || 'Jane Doe'}</Name>
        <Bio>{node.content?.bio || 'Senior Redakteurin im Bereich Telekommunikation und Netzwerk-Architektur. Schreibt leidenschaftlich gerne über 5G und neue Technologien.'}</Bio>
      </Content>
    </Wrapper>
  );
};

registry.register('author_box', {
  label: 'Autoren Box',
  icon: '👤',
  category: 'dynamic',
  defaultContent: {},
  defaultStyle: { desktop: { width: '100%' } },
  render: AuthorBoxWidget,
  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Autordaten',
          fields: [
            { name: 'content.name', label: 'Name (Fallback)', type: 'text' },
            { name: 'content.bio', label: 'Biografie', type: 'textarea' },
            { name: 'content.avatarUrl', label: 'Avatar Bild URL', type: 'text' }
          ]
        }
      ]
    }, {
      tab: 'style', groups: [{ title: 'Dimensionen', fields: [{name:'style.desktop.width', label:'Maximale Breite', type:'text'}] }]
    }
  ]
});
